import { useEffect } from 'react';

/**
 * Hook to handle Escape key press
 * @param {Function} onEscape - Callback to execute when Escape is pressed
 * @param {boolean} isActive - Whether the handler is active
 */
export const useEscapeKey = (onEscape, isActive = true) => {
  useEffect(() => {
    if (!isActive) return;

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onEscape();
      }
    };

    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onEscape, isActive]);
};
